import { gql } from '@apollo/client';

export const SHIPPING_RATES = gql`
  query GetShippingRates($shippingRates: ShippingRatesInput!) {
    getShippingRates(shippingRates: $shippingRates) {
      customerTransactionId
      output {
        alerts {
          alertType
          code
          message
        }
        encoded
        quoteDate
        rateReplyDetails {
          serviceType
          serviceName
          packagingType
          customerMessages {
            code
            message
          }
          ratedShipmentDetails {
            rateType
            ratedWeightMethod
            totalDiscounts
            totalBaseCharge
            totalNetCharge
            totalVatCharge
            totalNetFedExCharge
            totalDutiesAndTaxes
            totalNetChargeWithDutiesAndTaxes
            totalDutiesTaxesAndFees
            totalAncillaryFeesAndTaxes
            shipmentRateDetail {
              rateZone
              dimDivisor
              totalSurcharges
              totalFreightDiscount
              surCharges {
                type
                description
                amount
              }
              pricingCode
              currencyExchangeRate {
                fromCurrency
                intoCurrency
                rate
              }
              totalBillingWeight {
                units
                value
              }
              currency
            }
            currency
          }
          anonymouslyAllowable
          operationalDetail {
            originLocationIds
            commitDays
            serviceCode
            airportId
            scac
            originServiceAreas
            deliveryDay
            originLocationNumbers
            destinationPostalCode
            commitDate
            astraDescription
            deliveryDate
            deliveryEligibilities
            ineligibleForMoneyBackGuarantee
            maximumTransitTime
            astraPlannedServiceLevel
            destinationLocationIds
            destinationLocationStateOrProvinceCodes
            transitTime
            packagingCode
            destinationLocationNumbers
            publishedDeliveryTime
            countryCodes
            stateOrProvinceCodes
            ursaPrefixCode
            ursaSuffixCode
            destinationServiceAreas
            originPostalCodes
            customTransitTime
          }
          signatureOptionType
          serviceDescription {
            astraDescription
            code
            description
            names {
              encoding
              type
              value
            }
            operatingOrgCodes
            serviceCategory
            serviceId
            serviceType
          }
          commit {
            dateDetail {
              dayOfWeek
              dayCxsFormat
            }
          }
        }
      }
    }
  }
`;